import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Store } from 'lucide-react';

export default function VendorReviewBell() {
  const [jobs, setJobs] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  const fetchJobs = useCallback(async () => {
    try { const r = await api.get('/bid-engine/vendor-review'); setJobs(r.data.jobs || []); } catch { /* not admin or none pending */ }
  }, []);

  useEffect(() => { fetchJobs(); const t = setInterval(fetchJobs, 30000); return () => clearInterval(t); }, [fetchJobs]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  if (jobs.length === 0 && !open) return null;

  return (
    <div className="relative" ref={ref}>
      <Button variant="ghost" size="icon" className="relative" onClick={() => setOpen(!open)} data-testid="vendor-review-bell-btn">
        <Store className="h-5 w-5" strokeWidth={1.5} />
        {jobs.length > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-4 min-w-[16px] px-1 bg-amber-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center" data-testid="vendor-review-badge">
            {jobs.length > 99 ? '99+' : jobs.length}
          </span>
        )}
      </Button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-80 bg-card border rounded-sm shadow-lg z-50" data-testid="vendor-review-dropdown">
          <div className="flex items-center justify-between px-4 py-3 border-b">
            <h3 className="font-semibold text-sm">Vendor Names Needing Review</h3>
          </div>
          <div className="max-h-80 overflow-y-auto">
            {jobs.length === 0 ? (
              <div className="py-8 text-center text-muted-foreground text-sm">
                <Store className="h-8 w-8 mx-auto mb-2 opacity-30" />
                No pending vendor reviews
              </div>
            ) : (
              jobs.map(j => (
                <div key={j.id} className="px-4 py-3 border-b last:border-b-0 hover:bg-muted/50 cursor-pointer transition-colors"
                  onClick={() => { setOpen(false); navigate('/bid-engine'); }} data-testid={`vendor-review-bell-item-${j.id}`}>
                  <p className="text-sm font-medium truncate">"{j.vendor_name}"</p>
                  <p className="text-xs text-muted-foreground mt-0.5">by {j.user_name || 'Unknown'} · {new Date(j.created_at).toLocaleDateString()}</p>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
